import { getSourceUrl } from '../../resource/resource.mjs';
import { getThing } from '../../thing/thing.mjs';
import { internal_getAcr } from '../control.internal.mjs';

//
/** @hidden */
function getAccessControlResourceThing(resource) {
    const acr = internal_getAcr(resource);
    const acrUrl = getSourceUrl(acr);
    return getThing(acr, acrUrl);
}

export { getAccessControlResourceThing };
